export const DASHBOARD_LAYOUT = 'ftx-dashboard-layout'

export const DASHBOARD_TILE_OPEN = 'ftx-dashboard-tiles-open'
